"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var priceWithLabelStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        pricePrefixContainer: {
            display: 'flex',
        },
        pricePrefix: {
            fontFamily: typography.fontFamily2,
        },
        priceElement: {
            fontFamily: typography.fontFamily2,
            color: palette.text.primary,
        },
        label: {
            fontWeight: 'normal',
        },
    });
}, { name: 'Summary_PriceWithLabel' });
exports.default = priceWithLabelStyles;
